/**
 * Native <dialog> lightbox for links with class .lightbox
 *
 * @author jjarolim
 */

const DIALOG_ID = 'adw-lightbox';

/**
 * Create the shared dialog once and append it to the document body.
 *
 * @returns {HTMLDialogElement}
 */
const createDialog = () => {
    const dialog = document.createElement( 'dialog' );
    dialog.id = DIALOG_ID;
    dialog.className = 'adw-lightbox';
    dialog.setAttribute( 'aria-label', 'Lightbox' );

    dialog.innerHTML = `
        <div class="adw-lightbox__backdrop" data-lightbox-dismiss></div>
        <button type="button" class="adw-lightbox__close bmw-icon bmw-icon-close-rg" data-lightbox-dismiss aria-label="Schließen"></button>
        <iframe class="adw-lightbox__iframe" title="Lightbox Inhalt" allowfullscreen></iframe>
    `;

    document.body.appendChild( dialog );
    return dialog;
};

/**
 * @returns {HTMLDialogElement}
 */
const getDialog = () => {
    return document.getElementById( DIALOG_ID ) || createDialog();
};

/**
 * @param {string} url
 */
const open = ( url ) => {
    const dialog = getDialog();
    const iframe = dialog.querySelector( '.adw-lightbox__iframe' );

    iframe.src = url;
    dialog.showModal();
};

const close = () => {
    const dialog = getDialog();

    if ( ! dialog.open ) {
        return;
    }

    dialog.close();
};

/**
 * Dismiss on pointerdown – click is unreliable with a cross-origin iframe
 * inside the dialog. preventDefault avoids click-through onto the page.
 *
 * @param {PointerEvent} event
 */
const onDialogPointerDown = ( event ) => {
    if ( event.button !== 0 ) {
        return;
    }

    const dismissEl = event.target instanceof Element
        ? event.target.closest( '[data-lightbox-dismiss]' )
        : null;

    if ( ! dismissEl ) {
        return;
    }

    event.preventDefault();
    close();
};

/**
 * @param {MouseEvent} event
 */
const onDocumentClick = ( event ) => {
    const link = event.target instanceof Element
        ? event.target.closest( 'a.lightbox' )
        : null;

    if ( ! link ) {
        return;
    }

    const href = link.getAttribute( 'href' );

    if ( ! href || href === '#' ) {
        return;
    }

    event.preventDefault();
    open( href );
};

const init = () => {
    const dialog = getDialog();

    dialog.addEventListener( 'pointerdown', onDialogPointerDown );

    dialog.addEventListener( 'close', () => {
        const iframe = dialog.querySelector( '.adw-lightbox__iframe' );
        iframe.src = 'about:blank';
    } );

    document.addEventListener( 'click', onDocumentClick );
};

export { init };
